import { Application } from "@hotwired/stimulus"

import CheckAllController from "./check_all_controller"
import ComparisonTableController from "./comparison_table_controller"
import ComputedCostController from "./computed_cost_controller"
import DatatableController from "./datatable_controller"
import DatepickerController from "./datepicker_controller"
import InvoiceYearController from "./invoice_year_controller"
import ModalController from "./modal_controller"
import NumberInputController from "./number_input_controller"
import PvCalendarController from "./pv_calendar_controller"
import PvCommentaryPollController from "./pv_commentary_poll_controller"
import ReportPrintController from "./report_print_controller"
import SelectController from "./select_controller"
import SelectionModeController from "./selection_mode_controller"
import SidebarController from "./sidebar_controller"
import SidebarToggleController from "./sidebar_toggle_controller"
import TooltipController from "./tooltip_controller"

const application = Application.start()

application.register("check-all", CheckAllController)
application.register("comparison-table", ComparisonTableController)
application.register("computed-cost", ComputedCostController)
application.register("datatable", DatatableController)
application.register("datepicker", DatepickerController)
application.register("invoice-year", InvoiceYearController)
application.register("modal", ModalController)
application.register("number-input", NumberInputController)
application.register("pv-calendar", PvCalendarController)
application.register("pv-commentary-poll", PvCommentaryPollController)
application.register("report-print", ReportPrintController)
application.register("select", SelectController)
application.register("selection-mode", SelectionModeController)
application.register("sidebar", SidebarController)
application.register("sidebar-toggle", SidebarToggleController)
application.register("tooltip", TooltipController)
